import Tenant from "./Tenant";
import Site from "./Site";

export default class LabelPrinter {
  constructor(
    public id: number,
    public tenant: Tenant,
    public site: Site,
    public code: string,
    public address: string
  ) { }
}